export default __webpack_public_path__ + "reading-illustration.webp";